import type { ChangeEvent, ReactNode } from 'react';

import { Dialog, DialogContent, DialogDescription, DialogTitle } from 'design-system';
import ShareDialogContent from './ShareDialogContent';

const ShareDialog = ({
  open,
  onClose,
  content,
  emailError,
  handleChangeRecipient,
  header,
  recipient,
  shareUrl,
  onContentChange,
  onCopyClick,
  onSendEmail,
  enableSendEmail = true,
  renderLinkSection
}: {
  open: boolean;
  onClose: () => void;
  content: string;
  emailError: string;
  handleChangeRecipient: (recipient: string) => void;
  header: ReactNode;
  recipient: string;
  shareUrl?: string;
  onContentChange: (content: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  onCopyClick?: () => void;
  onSendEmail: () => void;
  enableSendEmail?: boolean;
  renderLinkSection?: ReactNode;
}) => {
  return (
    <Dialog
      onOpenChange={nextOpen => {
        if (!nextOpen) onClose();
      }}
      open={open}
    >
      <DialogContent className='z-[var(--z-dialog)]'>
        <DialogTitle>{typeof header === 'string' ? header : 'Share'}</DialogTitle>
        <ShareDialogContent
          content={content}
          emailError={emailError}
          enableSendEmail={enableSendEmail}
          handleChangeRecipient={e => {
            handleChangeRecipient(e.target.value);
          }}
          header={header}
          recipient={recipient}
          renderLinkSection={renderLinkSection}
          shareUrl={shareUrl}
          showHeader={false}
          onContentChange={onContentChange}
          {...(onCopyClick && { onCopyClick })}
          onSendEmail={onSendEmail}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ShareDialog;
